import { useEffect, useState, useRef } from "react";
import {
  HiDotsVertical,
  HiOutlinePencil,
  HiOutlineTrash,
} from "react-icons/hi";
import ColorsCircles from "./colors-roles";
import { useRecoilValue } from "recoil";
import toast, { Toaster } from "react-hot-toast";
import { includes } from "lodash";
import { AiOutlineClose } from "react-icons/ai";
import { InputIcon } from "../../../../components/inputs/input-icon";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { ButtonIcon } from "../../../../components/buttons/button-icon";
import TableComponent from "../../../../components/table/table-component";
import { useChargesAction } from "../../../../services/actions/charges.action";
import { chargesAtom } from "../../../../services/atoms/charges.atoms";
import EditChargeModal from "./edit-charge-modal";
import CreateChargesModal from "./create-charges";
import { MdArrowForwardIos } from "react-icons/md";
import { ROUTES } from "../../../../helpers/constants";
import { useNavigate } from "react-router-dom";
import { userAtom } from "../../../../services/atoms/auth.atoms";

const options = [
  {
    id: "opt-1",
    title: "Editar Perfil",
    action: "edit",
    icon: HiOutlinePencil,
  },
  {
    id: "opt-2",
    title: "Eliminar Perfil",
    action: "remove",
    icon: HiOutlineTrash,
  },
];

const columns = [
  {
    Header: "Perfil Profesional",
    accessor: ({ name }) => <div>{name}</div>,
  },
  {
    Header: "Descripción",
    accessor: ({ description }) => (
      <div
        style={{
          maxWidth: "350px",
          overflowWrap: "break-word",
          alignContent: "start",
        }}
      >
        <spans style={{ alignText: "start" }}>
          {description && description?.length <= 70
            ? description
            : `${description?.slice(0, 70)}...` || ""}
        </spans>
      </div>
    ),
  },
  {
    Header: "Competencias",
    accessor: ({ competences }) => (
      <div className="gm-table-competences-selected">
        {competences &&
          competences?.map((skills) => (
            <div key={skills.id}>
              {" "}
              <span> {skills.name}</span>{" "}
              <div>
                {skills &&
                  skills?.colorType.map((colors) => (
                    <ColorsCircles colors={colors} />
                  ))}
              </div>
            </div>
          ))}
      </div>
    ),
  },
  {
    Header: "Acciones",
    accessor: "",
    disableFilters: true,
    disableSortBy: true,
    type: "actions",
  },
];

const initialSetOpenState = {
  create: false,
  edit: false,
};

const initialChargeData = {
  id: "",
  description: "",
  competences: [],
  currentClientsId: "",
  type: "",
};

const initialSearchValue = { name: "", colorType: [] };

const Charges = () => {
  const { paginateCharges, deleteCharge } = useChargesAction();
  const navigate = useNavigate();
  const charges = useRecoilValue(chargesAtom);
  const user = useRecoilValue(userAtom);
  const [open, setOpen] = useState(initialSetOpenState);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [charge, setCharge] = useState(initialChargeData);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const [filter, setFilter] = useState(false);
  const handleChangePage = (e) => setPage(e + 1);

  const handleSetLimit = (e) => setLimit(e);

  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleOptionAction = (action, row) => {
    if (action === "edit") {
      if ( (user?.data.isAdmin || user?.data?.isAdminBasic) && row.currentClientsId === "") {
        return toast.error(
          "No tienes permiso para editar un perfil profesional de tipo general."
        );
      }
      setCharge(row);
      setOpen((modal) => ({ ...modal, edit: true }));
    }
    if (action === "remove") {
      if ((user?.data.isAdmin || user?.data?.isAdminBasic)  && row.currentClientsId === "") {
        return toast.error(
          "No tienes permiso para eliminar un perfil profesional de tipo general."
        );
      }
      setCharge(row);
      handleDeleteSkill(row, "este perfil profesional");
    }
  };
  const handleOpenDetails = (e, index) => {
    navigate(`${ROUTES.PARAMS.route}/charges/${e.id}`, {
      state: { charge: e, index: `${index}` },
    });
  };

  const actions = [
    { icon: HiDotsVertical, dropdown: true },
    { icon: MdArrowForwardIos, action: handleOpenDetails },
  ];

  const handleSearchByName = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let form = Object.fromEntries(data.entries());
    let search = { column: "position.name", value: form["search"] };
    setSearch(form["search"]);
    user?.data?.isSuperAdmin
      ? paginateCharges({ page, limit, search })
      : paginateCharges({
          page,
          limit,
          search,
          clientId: user?.data?.clientId,
        });
  };

  const handleChangeColor = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue !== "false") {
      const color = event.target.value;
      let search = { column: "competences.colorType", value: [color] };
      setSearch(selectedValue);
      paginateCharges({ page, limit, search: search });
    } else {
      return;
    }
  };

  const handleCleanSearch = () => {
    setSearch("");
    setSearchValue(initialSearchValue);
    user?.data?.isSuperAdmin
      ? paginateCharges({ page, limit })
      : paginateCharges({ page, limit, clientId: user?.data?.clientId });
    // resetSelect();
  };

  const resetSelect = () => {
    const select = document.querySelector('select[name="origen"]');
    select.selectedIndex = 0;
  };

  const handleConfirm = (toastId, row) => {
    deleteCharge(row.id, (res) => {
      if (includes(res?.message, "Request failed with status")) {
        toast.error("El perfil profesional no se ha podido eliminar", {
          duration: 4000,
        });
        toast.dismiss(toastId);
      } else {
        toast.success("Perfil profesional eliminado exitosamente", {
          duration: 4000,
        });
        toast.dismiss(toastId);
        user?.data?.isSuperAdmin
          ? paginateCharges({ page, limit })
          : paginateCharges({ page, limit, clientId: user?.data?.clientId });
      }
    });
  };

  const handleCancel = (toastId) => {
    toast.dismiss(toastId);
  };

  const handleDeleteSkill = (row, text) => {
    toast(
      (t) => (
        <div className="gm-modal-form-group">
          <p style={{ color: "#003849" }}>
            ¿Estás seguro de que quieres eliminar {text}?
          </p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="gm-secondary-button"
              onClick={() => handleCancel(t.id)}
            >
              Cancelar
            </button>
            <button
              className="gm-primary-button"
              onClick={() => handleConfirm(t.id, row)}
            >
              Confirmar
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  useEffect(() => {
    user?.data?.isSuperAdmin
      ? paginateCharges({ page, limit })
      : paginateCharges({
          page,
          limit,
          clientId: user?.data?.clientId,
          isFiltered: filter,
        });
    //eslint-disable-next-line
  }, [page, limit, filter]);

  return (
    <div className="gm-configurations-screen-container">
      <Toaster />
      {open.edit && (
        <EditChargeModal
          open={open.edit}
          toggle={() => handleOpenModal("edit")}
          update={() =>
            user?.data?.isSuperAdmin
              ? paginateCharges({ page, limit })
              : paginateCharges({ page, limit, clientId: user?.data?.clientId })
          }
          setCharge={setCharge}
          charge={charge}
          currentClientsId={user?.data?.clientId}
        />
      )}
      {open.create && (
        <CreateChargesModal
          open={open.create}
          toggle={() => handleOpenModal("create")}
          update={() =>
            user?.data?.isSuperAdmin
              ? paginateCharges({ page, limit })
              : paginateCharges({ page, limit, clientId: user?.data?.clientId })
          }
          currentClientsId={user?.data?.clientId}
          superAdmin={user?.data?.isSuperAdmin}
        />
      )}

      <div className="gm-ts-searchbar-container">
        <div className="gm-ts-searchbar-title-container">
          <form onSubmit={(e) => handleSearchByName(e, "name")}>
            <InputIcon
              Icon={HiMagnifyingGlass}
              type="text"
              placeholder="Buscar por nombre"
              name="search"
              value={searchValues.name}
              onChange={(e) => handleChangeValue("name", e.target.value)}
            />
          </form>
          {(user?.data.isAdmin || user?.data?.isAdminBasic) && (
            <form>
              <div className="gm-modal-checkbox-section">
                <label>Ocultar cargos generales</label>
                <input
                  className="input-checkbox"
                  type="checkbox"
                  value="azul"
                  checked={filter}
                  onClick={() => setFilter(!filter)}
                />
              </div>
            </form>
          )}
          {searchExists && (
            <button
              className="gm-clean-search-button"
              onClick={handleCleanSearch}
              type="button"
            >
              <AiOutlineClose size={18} />
            </button>
          )}
        </div>
        <div className="gm-ts-searchbar-actions-container">
          <ButtonIcon
            buttonLabel="Crear Cargo"
            type="button"
            className="gm-primary-button"
            onClick={() => handleOpenModal("create")}
          />
        </div>
      </div>

      <div style={{ height: "50px" }}> </div>
      <TableComponent
        classNameBody="qs-table-body-params"
        data={charges?.payload || []}
        loading={charges.loading}
        emptyListInformer="small"
        columns={columns}
        handleOptionAction={handleOptionAction}
        handleChangePage={handleChangePage}
        handleSetLimit={handleSetLimit}
        controlledPageCount={
          charges?.total ? Math.ceil(charges.total / limit) : 1
        }
        actions={actions}
        options={options}
        section={{
          plural: "Perfiles Profesionales",
          singular: "Perfil Profesional",
        }}
        checkbox={false}
        manualPagination={true}
        pagination
      />
    </div>
  );
};

export default Charges;
